var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._g(_vm._b({tag:"component",attrs:{"forgot-password":true,"forgot-password-translations":_vm.translations,"forgot-password-settings":_vm.settings}},'component',_vm.mergedAttrExcludeTranslationsSettings,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }